import React, { useEffect, useRef } from "react";
import "./AboutHero.css";

const AboutHero = () => {
  const contentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!contentRef.current) return;

      const rect = contentRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 150) {
        contentRef.current.classList.add("show");
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="about-hero-section">
      <div className="about-hero-overlay"></div>

      <div ref={contentRef} className="about-hero-content">
        <h1>Transform Your Business With Digital Tecgnology.</h1>
        <p>
          Our brand strategy services help define your unique value, understand
          your audience, and position your business powerfully in the market.
          Let's build your brand together with confidence.
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
